__turbopack_context__.v({
  "link": "s779Ia_link",
  "links": "s779Ia_links",
});
